import { Navigate } from "react-router-dom";
import React from "react";
import { getCookie } from "../section/cookie";

const PrivateRoute = ({ permissionsRequired, children }) => {
  const permissions = getCookie("permissions");
  const valid = getCookie("login");

  var rotePermissions = [];
  let validRole = false;

  if (permissionsRequired) {
    rotePermissions = permissionsRequired;
    validRole = rotePermissions.some((permission) =>
      permissions?.includes(permission)
    );
  } else {
    validRole = true;
  }

  if (valid) {
    if (validRole) {
      return children;
    }
    return <Navigate to="/PermissionError" />;

  } else {
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
